var _a, _b;
import { LocationType as ServiceV2LocationType, ServiceType as ServiceV2Type, } from '@wix/ambassador-bookings-services-v2-service/types';
import { ServiceLocationType, ServiceType, } from '@wix/bookings-uou-types';
var serviceTypeMapping = (_a = {},
    _a[ServiceV2Type.APPOINTMENT] = [ServiceType.INDIVIDUAL],
    _a[ServiceV2Type.CLASS] = [ServiceType.GROUP],
    _a[ServiceV2Type.COURSE] = [ServiceType.COURSE],
    _a);
var serviceLocationMapping = (_b = {},
    _b[ServiceV2LocationType.CUSTOM] = [ServiceLocationType.CUSTOM],
    _b[ServiceV2LocationType.BUSINESS] = [ServiceLocationType.OWNER_BUSINESS],
    _b[ServiceV2LocationType.CUSTOMER] = [ServiceLocationType.OWNER_CUSTOM],
    _b);
var mapImageToMediaItem = function (image) {
    return image && {
        height: image.height,
        width: image.width,
        relativeUri: image.url,
        fileName: image.filename || image.url,
        altText: image.altText,
    };
};
var mapLocations = function (location) {
    var _a, _b;
    return ({
        type: serviceLocationMapping[location.type],
        address: (_a = location.calculatedAddress) === null || _a === void 0 ? void 0 : _a.formattedAddress,
        locationText: (_b = location.calculatedAddress) === null || _b === void 0 ? void 0 : _b.formattedAddress,
        businessLocation: location.business,
    });
};
export var mapServiceV2ToService = function (service) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
    return ({
        id: service.id,
        info: {
            name: service.name,
            slugs: service.supportedSlugs
                .sort(function (slug1, slug2) { var _a, _b; return ((_a = slug2.createdDate) === null || _a === void 0 ? void 0 : _a.valueOf()) - ((_b = slug1.createdDate) === null || _b === void 0 ? void 0 : _b.valueOf()); })
                .map(function (slug) { return slug.name; }),
            type: (_a = serviceTypeMapping[service.type]) !== null && _a !== void 0 ? _a : ServiceType.INDIVIDUAL,
            tagline: service.tagLine,
            categoryId: (_b = service.category) === null || _b === void 0 ? void 0 : _b.id,
            categoryName: (_c = service.category) === null || _c === void 0 ? void 0 : _c.name,
            media: {
                mainMedia: mapImageToMediaItem((_e = (_d = service.media) === null || _d === void 0 ? void 0 : _d.mainMedia) === null || _e === void 0 ? void 0 : _e.image),
                coverMedia: mapImageToMediaItem((_g = (_f = service.media) === null || _f === void 0 ? void 0 : _f.coverMedia) === null || _g === void 0 ? void 0 : _g.image),
                gallery: (_j = (_h = service.media) === null || _h === void 0 ? void 0 : _h.items) === null || _j === void 0 ? void 0 : _j.map(function (item) {
                    return mapImageToMediaItem(item.image);
                }),
            },
            duration: (_o = (_m = (_l = (_k = service.schedule) === null || _k === void 0 ? void 0 : _k.availabilityConstraints) === null || _l === void 0 ? void 0 : _l.durations) === null || _m === void 0 ? void 0 : _m[0]) === null || _o === void 0 ? void 0 : _o.minutes,
        },
        locations: (_p = service.locations) === null || _p === void 0 ? void 0 : _p.map(mapLocations),
        // These service fields are not mapped because they are not used in bookings-app-builder-controllers
        policy: {},
        staffMembers: [],
        payment: {},
        videoConferenceProviderId: '',
        includeConferenceOption: false,
    });
};
export var mapStaffV1ToStaffDto = function (staffMember) { return ({
    resource: {
        id: staffMember.resourceId,
        name: staffMember.name,
        images: staffMember.mainMedia && [staffMember.mainMedia.image],
        description: staffMember.description,
        email: staffMember.email,
        phone: staffMember.phone,
    },
    slugs: [], // we don't have slugs in StaffMemberV1 API
}); };
//# sourceMappingURL=legacyMappers.js.map